/**
 * Formats a phone number to mask all but last 4 digits: (***) ***-1234
 */
export function formatMaskedPhoneNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length >= 4) {
    return `(***) ***-${digits.slice(-4)}`;
  }
  return phone;
}
